import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Sparkles, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 font-display font-bold text-xl mb-8 justify-center">
          <Sparkles className="w-6 h-6" /> SendOccasions
        </Link>
        <div className="nb-card p-8" data-testid="forgot-card">
          {sent ? (
            <div className="text-center">
              <div className="w-14 h-14 grid place-items-center rounded-xl bg-[#A8E6CF] border-2 border-[#0A0A0A] mx-auto"><MailCheck className="w-7 h-7" /></div>
              <h1 className="text-2xl font-display font-bold mt-4">Check your email</h1>
              <p className="text-[#4A4A4A] mt-2">If an account exists for <b>{email}</b>, we've sent a password reset link. It expires in 1 hour.</p>
              <Link to="/login" className="nb-btn bg-[#FFB5A7] px-6 py-3 mt-6 inline-flex">Back to log in</Link>
            </div>
          ) : (
            <form onSubmit={submit}>
              <h1 className="text-2xl sm:text-3xl font-display font-bold">Forgot password?</h1>
              <p className="text-[#4A4A4A] mt-2">Enter your email and we'll send you a secure reset link.</p>
              {error && <div className="nb-border rounded-xl bg-[#FFD5CC] px-4 py-3 mt-4 font-semibold text-sm" data-testid="forgot-error">{error}</div>}
              <label className="block mt-5">
                <span className="text-xs font-bold uppercase tracking-widest">Email</span>
                <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input"
                  className="w-full nb-border rounded-xl px-4 py-3 bg-[#FDFBF7] mt-1.5 focus:outline-none focus:ring-2 focus:ring-[#A8E6CF]" placeholder="you@email.com" />
              </label>
              <button type="submit" disabled={loading} data-testid="forgot-submit" className="nb-btn bg-[#FFB5A7] w-full py-3.5 mt-5">
                {loading ? "Sending…" : "Send reset link"}
              </button>
              <Link to="/login" className="flex items-center justify-center gap-1 text-sm font-semibold mt-5"><ArrowLeft className="w-4 h-4" /> Back to log in</Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
